import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistroEscolaridadComponent } from "./registro-escolaridad/lista.component";
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: 'control-escolar/registro-escolaridad',
    children: [
      { path: 'lista', component: RegistroEscolaridadComponent }
    ],
    canActivate: [AuthGuard] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class SecretariaEducacionRoutingModule { }

